import { h, Component } from 'preact';
import { API_ORIGIN, post } from 'utils/api';
// import { joinClasses } from 'utils/utils';

import ContactLink from 'components/contactLink/contactLink';
import Powster from 'components/icons/powster';
import Button from 'components/button/button';
import GoogleIcon from 'components/icons/google';
import MicrosoftIcon from 'components/icons/microsoft';
// import MailIcon from 'components/icons/mail';

import s from 'components/login/login.sss';

const qs = new URLSearchParams(typeof location !== 'undefined' ? location.search : '');

export default class Login extends Component {

	constructor(props) {
		super(props);
		this.state = {
			magicLinkState: 'ready',
			magicLinkTo: '',
		};
		// this.renderListeners = [];

		this.onSSOClick = this.onSSOClick.bind(this);
		// this.onMagicLinkSubmit = this.onMagicLinkSubmit.bind(this);
	}

	// componentWillUnmount() {
	// 	this.renderListeners.forEach((resolve) => resolve());
	// 	this.viewTransition?.skipTransition();
	// }

	// componentDidUpdate() {
	// 	this.renderListeners.forEach((resolve) => resolve());
	// 	this.renderListeners.length = 0;
	// }

	// async waitForRender() {
	// 	return new Promise(resolve => this.renderListeners.push(resolve));
	// }

	// transition(stateUpdate) {
	// 	if (!document.startViewTransition) return stateUpdate();

	// 	this.viewTransition = document.startViewTransition(async () => {
	// 		stateUpdate();
	// 		await this.waitForRender();
	// 	});
	// }

	ssoUrl(path) {
		return new URL(path, API_ORIGIN).href;
	}

	loginPopup(url, features) {
		const windowFeatures = Object.entries({
			popup: true,
			width: 550,
			height: 600,
			...features,
		}).map(data => data.join('=')).join(',');

		window.open(url, 'login', windowFeatures);
	}

	onSSOClick(e) {
		const link = e.target.closest('a');
		if (!link) return;
		e.preventDefault();
		this.loginPopup(link.href);
	}

	// async onMagicLinkSubmit(e) {
	// 	e.preventDefault();
	// 	const email = e.target?.elements?.email?.value || '';
	// 	if (!email) return;
	// 	this.setState({ magicLinkState: 'loading' });
	// 	try {
	// 		await post('/auth/login/magic-link', { email });
	// 		this.transition(() => this.setState({ magicLinkState: 'sent', magicLinkto: email }));
	// 	} catch {
	// 		this.setState({ magicLinkState: 'error' });
	// 	}
	// }

	renderHeader(text) {
		return (
			<div class={s.header}>
				<Powster class={s.logo} />
				<h2>{text}</h2>
			</div>
		);
	}

	renderHelp() {
		return (
			<p class={s.help}>
				Issues logging in? <ContactLink subject="Universal CMS login issue">Contact us</ContactLink>
			</p>
		);
	}

	render(props, state) {
		// Show Google login for local and demo environments, or if the powster-login query string is present
		const showGoogleLogin = !!(__IS_LOCAL__ || __IS_DEMO__) || qs.has('powster-login');

		// if (state.magicLinkState === 'sent') {
		// 	return (
		// 		<dialog class={joinClasses(s.wrapper, s.magicLinkConfirmation)} id="login">
		// 			<div class={s.content}>
		// 				{this.renderHeader('Check your email')}
		// 				<MailIcon height="56" class={s.icon} />
		// 				<p>We've sent a link to <strong>{state.magicLinkto || 'your email'}</strong> to log in</p>
		// 			</div>
		// 			{this.renderHelp()}
		// 		</dialog>
		// 	);
		// }

		return (
			<dialog class={s.wrapper} id="login">
				{this.renderHeader('Sign in to Powster CMS')}
				<div class={s.sso} onClickCapture={this.onSSOClick}>
					{showGoogleLogin && <Button outline icon={GoogleIcon} iconAlt="empty" href={this.ssoUrl('/login')}>Continue with Google</Button>}
					<Button outline icon={MicrosoftIcon} iconAlt="empty" href={this.ssoUrl('/microsoft-login')}>Sign in with Microsoft</Button>
				</div>
				{/* <hr class={s.sep} />
				<form
					class={joinClasses(s.magicLink, state.magicLinkState === 'loading' && s.loading)}
					action={`${API_ORIGIN}/auth/login/magic-link`}
					method="POST"
					onSubmit={this.onMagicLinkSubmit}
				>
					<label>
						Email Address
						<input type="email" name="email" required />
					</label>
					<Button primary type="submit" disabled={state.magicLinkState === 'loading'}>Continue</Button>
					<div class={joinClasses(s.error, state.magicLinkState === 'error' && s.show)}>Sorry, an error occured</div>
					{this.renderHelp()}
				</form> */}
				{this.renderHelp()}
			</dialog>
		);
	}
}